/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Elecconsodefect2Inputs */



/**
* | output |
* | --- |
* | "Electricity consumption fault" |
*
* @param {Ahu_History_Key_Elecconsodefect2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_elecconsodefect2 = /** @type {((inputs?: Ahu_History_Key_Elecconsodefect2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Elecconsodefect2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Electricity consumption fault")
	return /** @type {LocalizedString} */ ("Défaut consommation électrique")
});
export { ahu_history_key_elecconsodefect2 as "ahu_history_key_elecConsoDefect" }